const middleware = {}

middleware['handle404'] = require('..\\middleware\\handle404.js')
middleware['handle404'] = middleware['handle404'].default || middleware['handle404']

middleware['header'] = require('..\\middleware\\header.js')
middleware['header'] = middleware['header'].default || middleware['header']

export default middleware
